import React from 'react'
import { useTranslation } from 'react-i18next';

const EmptyDiscussion = () => {
    const { t } = useTranslation();
    return (
        <div className='d-flex flex-column align-items-center justify-content-center' style={{height: '250px'}}>
            <span className="fa-stack fa-2x">
                <i className="fas fa-envelope fa-stack-1x"></i>
            </span>
            <h6>{t("Aucune discussion disponible")}</h6>
        </div>
    )
}

export default EmptyDiscussion